__turbopack_context__.v({
  "AnsimPartner": "AnsimPartner-module-scss-module__WJFzfq__AnsimPartner",
  "PartnerItemCard": "AnsimPartner-module-scss-module__WJFzfq__PartnerItemCard",
  "bottomSheetCta": "AnsimPartner-module-scss-module__WJFzfq__bottomSheetCta",
  "cancelButton": "AnsimPartner-module-scss-module__WJFzfq__cancelButton",
  "cardContent": "AnsimPartner-module-scss-module__WJFzfq__cardContent",
  "confirmButton": "AnsimPartner-module-scss-module__WJFzfq__confirmButton",
  "filterItem": "AnsimPartner-module-scss-module__WJFzfq__filterItem",
  "hiddenButton": "AnsimPartner-module-scss-module__WJFzfq__hiddenButton",
  "highlightText": "AnsimPartner-module-scss-module__WJFzfq__highlightText",
  "inner": "AnsimPartner-module-scss-module__WJFzfq__inner",
  "noData": "AnsimPartner-module-scss-module__WJFzfq__noData",
  "noDataContent": "AnsimPartner-module-scss-module__WJFzfq__noDataContent",
  "partnerFilter": "AnsimPartner-module-scss-module__WJFzfq__partnerFilter",
  "partnerInfo": "AnsimPartner-module-scss-module__WJFzfq__partnerInfo",
  "partnerItemButton": "AnsimPartner-module-scss-module__WJFzfq__partnerItemButton",
  "partnerListContainer": "AnsimPartner-module-scss-module__WJFzfq__partnerListContainer",
  "partnerListSwiper": "AnsimPartner-module-scss-module__WJFzfq__partnerListSwiper",
  "partnerListSwiperSlide": "AnsimPartner-module-scss-module__WJFzfq__partnerListSwiperSlide",
  "premiumBadge": "AnsimPartner-module-scss-module__WJFzfq__premiumBadge",
  "priceCountItem": "AnsimPartner-module-scss-module__WJFzfq__priceCountItem",
  "priceCountSeparator": "AnsimPartner-module-scss-module__WJFzfq__priceCountSeparator",
  "priceCounts": "AnsimPartner-module-scss-module__WJFzfq__priceCounts",
  "safeBadge": "AnsimPartner-module-scss-module__WJFzfq__safeBadge",
  "swiperButton": "AnsimPartner-module-scss-module__WJFzfq__swiperButton",
  "swiperButtonContainer": "AnsimPartner-module-scss-module__WJFzfq__swiperButtonContainer",
  "title": "AnsimPartner-module-scss-module__WJFzfq__title",
  "titleContent": "AnsimPartner-module-scss-module__WJFzfq__titleContent",
  "wrap": "AnsimPartner-module-scss-module__WJFzfq__wrap",
});
